import { useEffect, useState } from "react";
import NxtbnDrawer from "../drawer";
import { InputField, NXForm } from "../common";
import useApi from "../../api";
import { toast } from "react-toastify";
import SelectStyled from "../Select";
import { makeEnumFriendly } from "../../enum";
import { NXDelete, NXSearch } from "../../icons";
import { fetchWarehouse } from "../../redux/warehosueSlice";

import VariantChooser from "./VariantChooser";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

interface StockFormProps {
  isOpen: boolean;
  onClose: () => void;
  refresh: () => void;
}

function StockForm({ isOpen, onClose, refresh }: StockFormProps) {
  const [formData, setFormData] = useState<any>();
  const [errorData, setErrorData] = useState<any>()
  const [variantChooser, setVariantChooser ] = useState<boolean>(false)
  const [selectedVariant, setSelectedVariant] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const api = useApi();

  const dispatch = useDispatch();
  const warehouse = useSelector((state: RootState) => state.warehouse);



  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  };

  const handleSelectChange = (name:any, value:any) => {
    setFormData((prev:any)=>({
      ...prev,
      [name]: value
    }))
  }

  

 

  useEffect(()=>{
    setFormData((prev:any)=>({...prev, product_variant: selectedVariant?.id}))
  }, [selectedVariant])

  const onSubmit = (e:any) => {
    e.preventDefault()
    api.createStock(formData).then((response:any)=>{
      toast.success('Successfuly created stock.')
      refresh()
      onClose()
    }).catch((error:any)=>{
      setErrorData(error.response.data)
      toast.error('Error creating stock.')
  })
  }

  const handleSearch = (e: any) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (value.length > 0) {
      setVariantChooser(true);
    } else {
      setVariantChooser(false);
    }
  };

   const fetchWarehosue = () => {
      if (!warehouse.results.length){
        dispatch(fetchWarehouse() as any);
      }
    };
  
    useEffect(() => {
      fetchWarehosue();
    }, []);

  return (
    <NxtbnDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={"Add Stock"}
    >
      <NXForm
        className="p-4"
        onSubmit={onSubmit}
        title=""
        nonFieldError={{}}
      >
        <div>
            <label className="block text-sm font-medium text-gray-700">
              Product Variant
            </label>
            <div className="relative w-full mb-4">
              <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
            <InputField
                type="text"
                placeholder="Search products"
                onChange={handleSearch}
                className="p-[12px] bg-secondary-50 rounded-lg border-none outline-none pl-[3.1rem] w-full"
              />
            </div>
          </div>

      {selectedVariant ? (
        <table className="min-w-full divide-y divide-gray-200 shadow border-b my-4">

          <thead>
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Variant
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                SKU
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>

          <tbody>

              <tr className="bg-white">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="">
                      <div className="text-sm font-medium text-gray-900">{selectedVariant.name}</div>
                      <div className="text-sm text-gray-500">#ID {selectedVariant.id}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="">
                      <div className="text-sm font-medium text-gray-900">{selectedVariant.sku}</div>

                    </div>
                  </div>
                </td>

                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    type="button"
                    onClick={() => setSelectedVariant(null)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <NXDelete />
                  </button>
                </td>
              </tr>
          </tbody>
        </table>  ) : <p className="my-4">No Variant Selected</p>}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label htmlFor="Warehouse" className="block text-sm font-medium text-gray-700">
              Warehouse
            </label>              
                <SelectStyled
                  name="warehouse"
                 
                  options={makeEnumFriendly(warehouse.results || [])}
                  onChange={(e)=>handleSelectChange('warehouse', e.value)}
                  className="mt-1"
                  errorData={errorData}
                />
          </div>
          <div>
            <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">
              Quantity
            </label>
            <InputField
              type="number"
              name="quantity"
              placeholder="quantity"
              value={formData?.quantity}
              onChange={handleInputChange}
              required
              className="mt-1 w-full p-2 border rounded"
              errorData={errorData}
            />
          </div>


        </div>

        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="px-4 py-2 text-white bg-[#0CAF60] hover:bg-[#098d4d] disabled:bg-[#0caf609a] text-sm font-medium rounded-md shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {"Create Stock"}
          </button>
        </div>
      </NXForm>

      <VariantChooser
        parentSearchTerm={searchQuery} 
        isOpen={variantChooser} 
        onClose={()=>setVariantChooser(!variantChooser)} 
        onSelect={(variant:any)=>{
          setSelectedVariant(variant)
        }}
      />
    </NxtbnDrawer>
  );
}

export default StockForm;